// src/i18n.ts — interface uniquement en français pour l’instant
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  fr: {
    translation: {
      "login.username": "Nom d'utilisateur",
      "login.password": "Mot de passe",
      "login.submit": "Se connecter",
      "login.subtitle": "Veuillez vous connecter",
      "login.loading": "Connexion...",
      "errors.network_error": "Erreur réseau. Réessayez.",
      "errors.unknown_error": "Erreur inconnue",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr",
  fallbackLng: "fr",
  supportedLngs: ["fr"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
